module.exports = __webpack_public_path__ + "static/media/IMG_3496_sm.0c44d286.jpg";